// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23333%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.issuance-wrap {
    background: #f5f7fb;
}

.issuance-viewport {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
}

/* 헤더 */
.issuance-header {
    padding: 18px 14px 8px;
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 100;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.issuance-logo {
    width: 110px;
    height: auto;
    object-fit: contain;
    cursor: pointer;
}

/* 폼 */
.issuance-form {
    gap: 14px;
    padding: 0 20px 90px;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    min-height: 0;
    overflow-y: auto;
}

.issuance-title {
    margin-top: 15px;
    font-size: 18px;
    font-weight: 900;
}

/* 카드(자격증 정보) */
.issuance-card {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    display: grid;
    gap: 10px;
}

.issuance-row {
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    align-items: flex-start;
    gap: 10px;
}

.issuance-row>label {
    font-size: 13px;
    color: #6b7280;
    height: 24px;
    line-height: 24px;
}

.issuance-value {
    font-weight: 700;
    color: #111;
}

/* 주소 */
.issuance-section {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    display: grid;
    gap: 12px;
}

.issuance-input-group {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 72px;
    gap: 8px;
}

.issuance-input {
    height: 40px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0 12px;
    font-size: 15px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
}

.issuance-input[type="select"],
select.issuance-input {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 32px;
    cursor: pointer;
}

.issuance-input:focus {
    border-color: #89a9ff;
    box-shadow: 0 0 0 3px rgba(47, 134, 255, .15);
}

.issuance-btn {
    height: 40px;
    padding: 0 14px;
    border: none;
    border-radius: 10px;
    background: #2f86ff;
    color: #fff;
    font-weight: 700;
    cursor: pointer;
}

.issuance-preview {
    display: grid;
    grid-template-columns: 72px 1fr;
    gap: 10px;
    align-items: center;
    font-size: 13px;
    color: #6b7280;
}

.issuance-preview-value {
    color: #111;
    font-weight: 600;
}

/* 금액 + 결제 */
.issuance-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 4px;
    font-size: 16px;
}

.issuance-amount strong {
    font-size: 18px;
}

/* 하단 고정 버튼 컨테이너 */
.issuance-button-container {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 600px;
    padding: 12px 20px;
    background: #fff;
    /* box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1); */
    z-index: 100;
}

.issuance-pay {
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 8px;
    background: #1C6DD0;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    box-shadow: 0 2px 8px rgba(28, 109, 208, 0.2);
}

.issuance-pay:hover {
    background: #1558A8;
}

.issuance-pay:active {
    background: #0d4a8a;
}

/* ----- 주소검색 모달 ----- */
.issuance-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 16px;
    overflow: hidden;
}

.issuance-modal {
    width: min(720px, 100%);
    max-height: 90vh;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, .25);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.issuance-modal-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
}

.issuance-close {
    border: none;
    background: #000;
    color: #fff;
    border-radius: 8px;
    padding: 6px 10px;
    cursor: pointer;
}

.issuance-modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

/* 토스트 */
.issuance-toast {
    position: fixed;
    left: 50%;
    bottom: 140px;
    transform: translateX(-50%);
    background: #111;
    color: #fff;
    padding: 10px 14px;
    border-radius: 999px;
    font-size: 14px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, .22);
    animation: issuanceToast 2.2s ease forwards;
    z-index: 9999;
}

@keyframes issuanceToast {
    0% {
        opacity: 0;
        transform: translate(-50%, 6px);
    }

    10% {
        opacity: 1;
        transform: translate(-50%, 0);
    }

    80% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        transform: translate(-50%, 6px);
    }
}

.issuance-pay:disabled,
.issuance-pay[aria-disabled="true"] {
    opacity: .5;
    cursor: not-allowed;
    box-shadow: none;
}

/* 이미지 업로드 */
.issuance-image-upload {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.issuance-image-label {
    font-size: 13px;
    color: #6b7280;
    height: 24px;
    line-height: 24px;
}

.issuance-image-container {
    width: 100%;
}

.issuance-image-upload-area {
    width: 100%;
    min-height: 150px;
    border: 2px dashed #e5e7eb;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f9fafb;
    transition: all 0.2s;
}

.issuance-image-upload-area:hover {
    border-color: #89a9ff;
    background: #f0f4ff;
}

.issuance-image-upload-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    padding: 20px;
    color: #6b7280;
    font-size: 14px;
}

.issuance-image-upload-button span:first-child {
    font-size: 32px;
    font-weight: 300;
    color: #9ca3af;
}

.issuance-image-preview-wrapper {
    position: relative;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
}

.issuance-image-preview {
    width: 100%;
    height: auto;
    display: block;
    /* max-height: 400px; */
    object-fit: contain;
}

.issuance-image-remove {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    border: none;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    transition: background 0.2s;
}

.issuance-image-remove:hover {
    background: rgba(0, 0, 0, 0.8);
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/issuance.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,OAAO;AACP;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,MAAM;AACN;IACI,SAAS;IACT,oBAAoB;IACpB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,OAAO;AACP;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yDAAuL;IACvL,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA,QAAQ;AACR;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,yCAAyC;IACzC,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,+BAA+B;IACnC;;IAEA;QACI,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,+BAA+B;IACnC;AACJ;;AAEA;;IAEI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".issuance-wrap {\r\n    background: #f5f7fb;\r\n}\r\n\r\n.issuance-viewport {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    min-height: 100dvh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n/* 헤더 */\r\n.issuance-header {\r\n    padding: 18px 14px 8px;\r\n    display: flex;\r\n    justify-content: center;\r\n    position: sticky;\r\n    top: 0;\r\n    background: #fff;\r\n    z-index: 100;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.issuance-logo {\r\n    width: 110px;\r\n    height: auto;\r\n    object-fit: contain;\r\n    cursor: pointer;\r\n}\r\n\r\n/* 폼 */\r\n.issuance-form {\r\n    gap: 14px;\r\n    padding: 0 20px 90px;\r\n    flex: 1 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* justify-content: center; */\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n}\r\n\r\n.issuance-title {\r\n    margin-top: 15px;\r\n    font-size: 18px;\r\n    font-weight: 900;\r\n}\r\n\r\n/* 카드(자격증 정보) */\r\n.issuance-card {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n    display: grid;\r\n    gap: 10px;\r\n}\r\n\r\n.issuance-row {\r\n    display: grid;\r\n    grid-template-columns: 72px minmax(0, 1fr);\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n}\r\n\r\n.issuance-row>label {\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n    height: 24px;\r\n    line-height: 24px;\r\n}\r\n\r\n.issuance-value {\r\n    font-weight: 700;\r\n    color: #111;\r\n}\r\n\r\n/* 주소 */\r\n.issuance-section {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n    display: grid;\r\n    gap: 12px;\r\n}\r\n\r\n.issuance-input-group {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) 72px;\r\n    gap: 8px;\r\n}\r\n\r\n.issuance-input {\r\n    height: 40px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 10px;\r\n    padding: 0 12px;\r\n    font-size: 15px;\r\n    outline: none;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.issuance-input[type=\"select\"],\r\nselect.issuance-input {\r\n    appearance: none;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 12px center;\r\n    padding-right: 32px;\r\n    cursor: pointer;\r\n}\r\n\r\n.issuance-input:focus {\r\n    border-color: #89a9ff;\r\n    box-shadow: 0 0 0 3px rgba(47, 134, 255, .15);\r\n}\r\n\r\n.issuance-btn {\r\n    height: 40px;\r\n    padding: 0 14px;\r\n    border: none;\r\n    border-radius: 10px;\r\n    background: #2f86ff;\r\n    color: #fff;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n}\r\n\r\n.issuance-preview {\r\n    display: grid;\r\n    grid-template-columns: 72px 1fr;\r\n    gap: 10px;\r\n    align-items: center;\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n}\r\n\r\n.issuance-preview-value {\r\n    color: #111;\r\n    font-weight: 600;\r\n}\r\n\r\n/* 금액 + 결제 */\r\n.issuance-amount {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0px 4px;\r\n    font-size: 16px;\r\n}\r\n\r\n.issuance-amount strong {\r\n    font-size: 18px;\r\n}\r\n\r\n/* 하단 고정 버튼 컨테이너 */\r\n.issuance-button-container {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 100%;\r\n    max-width: 600px;\r\n    padding: 12px 20px;\r\n    background: #fff;\r\n    /* box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1); */\r\n    z-index: 100;\r\n}\r\n\r\n.issuance-pay {\r\n    width: 100%;\r\n    height: 52px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: #1C6DD0;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n    box-shadow: 0 2px 8px rgba(28, 109, 208, 0.2);\r\n}\r\n\r\n.issuance-pay:hover {\r\n    background: #1558A8;\r\n}\r\n\r\n.issuance-pay:active {\r\n    background: #0d4a8a;\r\n}\r\n\r\n/* ----- 주소검색 모달 ----- */\r\n.issuance-modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, .45);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 9999;\r\n    padding: 16px;\r\n    overflow: hidden;\r\n}\r\n\r\n.issuance-modal {\r\n    width: min(720px, 100%);\r\n    max-height: 90vh;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 12px 40px rgba(0, 0, 0, .25);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.issuance-modal-bar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px 12px;\r\n    border-bottom: 1px solid #eee;\r\n    position: sticky;\r\n    top: 0;\r\n    background: #fff;\r\n    z-index: 1;\r\n}\r\n\r\n.issuance-close {\r\n    border: none;\r\n    background: #000;\r\n    color: #fff;\r\n    border-radius: 8px;\r\n    padding: 6px 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.issuance-modal-body {\r\n    flex: 1 1 auto;\r\n    overflow-y: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    overscroll-behavior: contain;\r\n}\r\n\r\n/* 토스트 */\r\n.issuance-toast {\r\n    position: fixed;\r\n    left: 50%;\r\n    bottom: 140px;\r\n    transform: translateX(-50%);\r\n    background: #111;\r\n    color: #fff;\r\n    padding: 10px 14px;\r\n    border-radius: 999px;\r\n    font-size: 14px;\r\n    box-shadow: 0 6px 16px rgba(0, 0, 0, .22);\r\n    animation: issuanceToast 2.2s ease forwards;\r\n    z-index: 9999;\r\n}\r\n\r\n@keyframes issuanceToast {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate(-50%, 6px);\r\n    }\r\n\r\n    10% {\r\n        opacity: 1;\r\n        transform: translate(-50%, 0);\r\n    }\r\n\r\n    80% {\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n        transform: translate(-50%, 6px);\r\n    }\r\n}\r\n\r\n.issuance-pay:disabled,\r\n.issuance-pay[aria-disabled=\"true\"] {\r\n    opacity: .5;\r\n    cursor: not-allowed;\r\n    box-shadow: none;\r\n}\r\n\r\n/* 이미지 업로드 */\r\n.issuance-image-upload {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.issuance-image-label {\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n    height: 24px;\r\n    line-height: 24px;\r\n}\r\n\r\n.issuance-image-container {\r\n    width: 100%;\r\n}\r\n\r\n.issuance-image-upload-area {\r\n    width: 100%;\r\n    min-height: 150px;\r\n    border: 2px dashed #e5e7eb;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #f9fafb;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.issuance-image-upload-area:hover {\r\n    border-color: #89a9ff;\r\n    background: #f0f4ff;\r\n}\r\n\r\n.issuance-image-upload-button {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    cursor: pointer;\r\n    padding: 20px;\r\n    color: #6b7280;\r\n    font-size: 14px;\r\n}\r\n\r\n.issuance-image-upload-button span:first-child {\r\n    font-size: 32px;\r\n    font-weight: 300;\r\n    color: #9ca3af;\r\n}\r\n\r\n.issuance-image-preview-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    border: 1px solid #e5e7eb;\r\n}\r\n\r\n.issuance-image-preview {\r\n    width: 100%;\r\n    height: auto;\r\n    display: block;\r\n    /* max-height: 400px; */\r\n    object-fit: contain;\r\n}\r\n\r\n.issuance-image-remove {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    color: #fff;\r\n    border: none;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    line-height: 1;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.issuance-image-remove:hover {\r\n    background: rgba(0, 0, 0, 0.8);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
